import { connect } from "react-redux";
import { setTypeCommentPost } from "../../../../store/action/settingPageAction";
import { COMMENT_TYPE } from "../../../../store/reducers/settingPapgeReducer";

const SettingSyntax = (props) => {
  const { settingPage, setTypeCommentPost } = props;
  const { type_comment } = settingPage;
  
  return (
    <div className="setting-syntax-wrapper">
      <div className="card">
        <div className="card-title mb16"><span>
          <div className="svg-next-icon card-title-icon view-all-icon">
          </div>
        </span>
          <span>
            Cú pháp khách bình luận để chốt đơn
          </span>
        </div>
        <div className="">
          <div className="app-next-input-radio syntax-item app-input-disabled" onClick={() => setTypeCommentPost(COMMENT_TYPE.FULL_KEYWORD)}>
            <label className="app-next-label--switch" htmlFor="choice1">
              <div className="syntax-item-label-wrapper">
                <div className="card-title font-medium text-sm m-none display-flex">
                  Bình luận có chứa Mã sản phẩm, Mã biến thể (nếu có) và Số điện thoại
                  {/* <div className="label-icon">
                    <div className="svg-next-icon mb2 icon-help-new">
                    </div>
                  </div> */}
                </div>
                <span className="card-subtitle text-xs m-none">
                  Ví dụ: Tôi muốn A1 xanh M 0123456789
                </span>
                <div className="label-overlay"></div>
              </div>
            </label>
            <input className="app-next-radio" id="choice1" type="radio" checked={type_comment == COMMENT_TYPE.FULL_KEYWORD} />
            <span className="app-next-radio--styled"></span>
          </div>
          <div className="app-next-input-radio syntax-item app-input-disabled" onClick={() => setTypeCommentPost(COMMENT_TYPE.ONLY_KEYWORD)}>
            <label className="app-next-label--switch"
              htmlFor="choice2">
              <div className="syntax-item-label-wrapper">
                <div className="card-title font-medium text-sm m-none display-flex">
                  Bình luận có chứa Mã sản phẩm
                </div>
                <span className="card-subtitle text-xs m-none">
                  Ví dụ: Tôi muốn A101
                </span>
                <div className="label-overlay"></div>
              </div>
            </label>
            <input className="app-next-radio" id="choice2" type="radio" checked={type_comment == COMMENT_TYPE.ONLY_KEYWORD} />
            <span className="app-next-radio--styled">
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  const { settingPage } = state;

  return {
    settingPage
  };
};

export default connect(mapStateToProps, {
  setTypeCommentPost
})(SettingSyntax)